import type { Size } from '@cvo/ui/types/designSystem';
import type { IconName, IconProps } from '@cvo/ui/components/atoms/Icon/Icon.model';

export type TagType = 'information' | 'success' | 'warning' | 'danger' | 'highlight' | 'neutral' | 'disabled' | 'inverse' | 'brand-primary' | 'brand-secondary';

export type TagStyle = 'filled' | 'subtle' | 'subtle-outlined' | 'outlined';

export interface TagProps {
  /** Semantic colour type */
  type?: TagType;
  /** Visual treatment */
  variant?: TagStyle;
  /** Size variant */
  size?: Exclude<Size, 'xl'>;
  /** Optional icon on the left side */
  leftIcon?: IconName;
  /** Optional icon on the right side */
  rightIcon?: IconName;
}

export const iconSizeMap: Record<Required<TagProps>['size'], IconProps['size']> = {
  xs: 'sm',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
};

